export default {
  addAccountContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 50px'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%'
  },
  input: {
    width: '90%',
    margin: '10px 0px'
  }
};
